/**
 * Ex data
 * TODO: Load from database
 */

import desings from "../../data/articles";

const INITIAL_STATE = {
  data: desings.data
};

const loadDedingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ADD_DESING":
      return { ...state, data: [...state.data, action.save] };
    case "UPDATE_DESING":
      return {
        ...state,
        data: [...state.data.map(d => (d.id === action.state.id ? action.state : d))]
      };
    case "DELETE_DESING":
      return {
        ...state,
        data: [...state.data.filter(d => d.id !== action.state.id)]
      };
    default:
      return state;
  }
};

export default loadDedingsReducer;
